import React from 'react';
import './ContactPage.scss'; // Modular SCSS import for Contact page
import ContactHeader from '../sections/ContactHeader/ContactHeader';
import ContactForm from '../sections/ContactForm/ContactForm';
import ContactInfo from '../sections/ContactInfo/ContactInfo';

/**
 * ContactPage Component
 * 
 * Pagina de contact a site-ului care permite utilizatorilor
 * să trimită mesaje și să vadă informațiile de contact
 */
const ContactPage = () => {
  return (
    <>
      <ContactHeader />
      <ContactForm />
      <ContactInfo />
    </>
  );
};

export default ContactPage;
